import { styled } from '@mui/material/styles';
import { Autocomplete, Box, FormControl, InputLabel, Select } from '@mui/material';
import { SvgChevronDownFill } from './SvgIcons';

// =====================================|| FormControl Styled ||===================================== //
export const SimFormControl = styled(FormControl)(({ theme }) => ({
  'label + div': {
    marginTop: theme.spacing(3),
  },
  '& .Mui-required': {
    paddingLeft: theme.spacing(2),
    '& .MuiFormLabel-asterisk': {
      color: theme.palette.error.main,
      position: 'absolute',
      left: 0,
      top: 3,
    }
  },
  '& .ant-picker': {
    borderColor: theme.palette.grey[400],
    borderRadius: 0,
  },
}));


export const SimFormLabel = styled(InputLabel)(({ theme }) => ({
  ...theme.typography.body1,
  top: 2,
  fontWeight: 400,
  color: theme.palette.text.primary,
}));

// NativeSelect
export const SimFormSelect = styled((props) => (
  <Select 
    IconComponent={(props) => {
      return (
        <Box className={`${props?.className} Sim-form-select-arrow`}>
          <SvgChevronDownFill size={24} />
        </Box>
      )
    }}
    {...props}
  />
))(
({ theme }) => ({
  '& .Sim-form-select-arrow': {
    display: 'flex',
    alignItems: 'center',
    top: 'calc(50% - 0.7em)',
    'svg': {
      color: theme.palette.grey[600],
      fill: theme.palette.grey[600]
    }
  }
}));


// Native Autocomplete
export const SimFormAutocomplete = styled((props) => (
  <Autocomplete
    popupIcon={
      <Box className={`${props?.className} Sim-form-autocomplete-arrow`}>
        <SvgChevronDownFill size={24} />
      </Box>
    }
    {...props}
  />
))(
({ theme }) => ({
  '& .Sim-form-autocomplete-arrow': {
    display: 'flex',
    alignItems: 'center',
    top: 'calc(50% - 0.7em)',
    'svg': {
      color: theme.palette.grey[600],
      fill: theme.palette.grey[600]
    }
  }
}));
